import { IMessage } from '../types/message';

export function mapMessage(message: IMessage) {
  return `${message.source}|:| ${message.content}`;
}
